import cloudbase from "@cloudbase/js-sdk/app";
import "@cloudbase/js-sdk/functions"
import { message } from 'antd';

const $cloud = cloudbase.init({
    env: "xueda-open-4gnbfjdbdb5795c5"
});

const BaseConfig = {
    name: 'zhijiao',
    loading: false,
    loadingText: '加载中...'
}

const request = async ($url, params = {}, options = {}) => {
    const config = Object.assign({}, BaseConfig, options);
    if (config.loading) {
        var hideLoading = message.loading(config.loadingText);
    }
    return new Promise((resolve, reject) => {
        $cloud.callFunction({
            name: config.name,
            data: {
                $url,
                ...params
            },
        })
            .then(res => {
                if (!res.code) {
                    if (config.success && typeof config.success === 'function') res = config.success(res);
                    resolve(res);
                }
                else {
                    console.log(`code:${res.code}`, `requestId：${res.requestId}`, `message:${res.message}`)
                    reject(res)
                }
            })
            .catch(err => {
                console.log('server catch=', err);
            })
            .finally(() => {
                if (hideLoading) hideLoading();
            })
    })
}

export default request